import moment from "moment";

export function taxCalculatation(taxes, amount) {
  let taxrate = 0;
  let perAmount = 0;

  if (taxes) {
    taxes.forEach((tax) => {
      taxrate += tax.amount;
      if (amount != undefined) {
        perAmount += (tax.amount * parseFloat(amount.toFixed(2))) / 100;
      }
    });
  } else {
    taxrate = undefined;
    perAmount = undefined;
  }

  if (amount != undefined) {
    return perAmount;
  } else {
    return taxrate;
  }
}


export const generateToken = () => {
  const header = {
    alg: "HS256",
    typ: "JWT",
  };

  const payload = {
    exp: Math.floor(Date.now() / 1000) + 60 * 60, // Token expires in 1 hour
    iat: Math.floor(Date.now() / 1000), // Issued at
    user: "exampleUser", // Example user data
  };

  const base64Encode = (obj) => {
    return btoa(
      JSON.stringify(obj)
        .replace(/=/g, "") // Remove padding
        .replace(/\+/g, "-") // Replace '+' with '-'
        .replace(/\//g, "_") // Replace '/' with '_'
    );
  };

  const headerEncoded = base64Encode(header);
  const payloadEncoded = base64Encode(payload);

  // Mock signature (not cryptographically secure)
  const signature = "mockSignature";

  return `${headerEncoded}.${payloadEncoded}.${signature}`;
};


function CurrencyFormatter(value, locale, currency) {
  if (value == null || isNaN(value)) {
    console.error("Invalid value passed to CurrencyFormatter:", value);
    return "Invalid Value"; // Return a fallback string
  }

  return value.toLocaleString(locale ? locale : "en-US", {
    style: "currency",
    currency: currency ? currency : "USD",
  });
}

 const getCurrency = () => {
  return localStorage.getItem("Currency") ? localStorage.getItem("Currency") : "₹";
};


function TimeFormatter(value, locale) {
  // later switch to session storage
  let time = new Date(value).toLocaleTimeString(locale ? locale : "en-US");
  return time;
}

function DateFormatter(value, locale) {
  // later switch to session storage
  let date = new Date(value).toLocaleDateString(locale ? locale : "en-US");

  return moment(date).format('DD-MM-YYYY');
}


function convertToISO(dateInput) {
  // Check if dateInput is provided, otherwise use the current date
  const date = dateInput ? new Date(dateInput) : new Date();
  return date.toISOString(); // Outputs: "yyyy-MM-ddTHH:mm:ss.SSSZ"
}


function convertISOToDDMMYYYY(isoDate) {
  return moment(isoDate).format('DD-MM-YYYY');
}

function getEndTime(startTime, durationMinutes) {
  const [hours, minutes] = startTime.split(':').map(Number);
  const end = new Date(0, 0, 0, hours, minutes + durationMinutes);
  return `${end.getHours().toString().padStart(2, '0')}:${end.getMinutes().toString().padStart(2, '0')}`;
}

export { CurrencyFormatter,getCurrency , DateFormatter, TimeFormatter, convertToISO , convertISOToDDMMYYYY ,getEndTime };
